<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Add Academic Year Details</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
        </v-row>

        <v-row justify="center" dense v-if="ay">
          <v-col cols="12" sm="3">
            <p><b>From Date</b></p>
            <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>To Date</b></p>
            <v-text-field outlined dense type="date" v-model="todate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Expected Number Of Training Hours(Minimum)</b></p>
            <v-text-field outlined dense type="number" v-model="expected_hours"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" dense v-if="ay && fromdate && todate && expected_hours">
          <v-btn color="primary" @click="save()">Save</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="ay_details != ''">
        <v-data-table :headers="headers" :items="ay_details">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>AcademicYear Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
    todate: new Date().toISOString().slice(0, 10),
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [], ay: "", expected_hours: 0,
    headers: [
      { text: "Academic Year", value: "ay" },
      { text: "Training Start Date", value: "training_start_date" },
      { text: "Training End Date", value: "training_end_date" },
      { text: "Expected No Of Hours", value: "expected_teacher_training_hours" },
    ],
    ay_details: [],
  }),
  methods: {
    save() {
      this.ay_details = []
      const data = {
        fromdate: this.fromdate,
        todate: this.todate,
        ay: this.ay,
        expected_hours: this.expected_hours
      };
      this.overlay = true;
      axios
        .post("/Admin/saveAyOtherDetails", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.ay_details = res.data.ay_details_only_isinerp;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
          this.expected_hours = 0;
        });
    },
    async onLoad() {
      try {
        const res = await axios.post("/Canteen/syncLearnerCanteenFees");
        if (res.data.flag == "YES") {
          this.ay_list = res.data.ay_list;
          this.ay = res.data.cay;
          this.ay_details = res.data.ay_details_only_isinerp;
        }
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      } finally {
        //this.save_loader = false;
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped></style>